import axios from 'axios';
import store from '../../store';

const model = () => {
	return {
		username: 	'',
		password: 	''
	};
};

const save = async (model) => {
	try {
		return model.id ? await axios.put(`/users/${model.id}`, model) : await axios.post(`/users`, model);
	} catch (err) {
		return false;
	}
};

const read = async(id) => {
	return (await axios.get(`/users/${id}`)).data;
};

const window = async (model, submit) => {
	store.dispatch('win/push', {
		component: 	'user-window-view',
		model:		model,
		async submit(model) {
			return await submit(model);
		}
	});
};

const open = async (id, onSave) => {
	window(id ? await read(id) : model(), async (model) => {
		const r = await save(model);

		if (r) {
			if (onSave) onSave(r);
			return true;
		}

		return false;
	});
};

const del = async (id) => {
	await axios.delete(`/users/${id}`);
};

export default {
	model,
	save,
	read,
	open,
	window,
	del
};